import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { Work, Bookmark } from '@mui/icons-material';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { Notifications } from '@mui/icons-material'; // Importing React Material Icon


function DashboardCard() {
  return (
    <div className="container">
      <div className="content-wrapper ">
        <div className="title delete-title">
          <h1><span className="orange-box"></span> Dashboard</h1>
        </div>

        <div className=" Alertcard">
          <div className="dashboard">
            <Grid container spacing={2} className="dash-section">
              <Grid item xs={6} md={3}>
                <Card className="dash-card">
                  <CardContent className='dash-content'>
                    <div>
                      <Work className="dash-icon dash-icon-blue" />
                    </div>

                    <div className='dash-points'>
                      <Typography variant="h6" className="dash-title">15</Typography>
                      <Typography variant="subtitle1">AppliedJobs</Typography>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card className="dash-card">
                  <CardContent className='dash-content' >
                    <ContentPasteSearchIcon className="dash-icon dash-icon-red" />

                    <div className='dash-points'>
                      <Typography variant="h6">2068</Typography>
                      <Typography variant="subtitle1">Views/Profile</Typography>
                    </div>

                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card className="dash-card">
                  <CardContent className='dash-content'>
                    <ThumbUpAltIcon className="dash-icon dash-icon-yellow " />

                    <div className='dash-points'>
                      <Typography variant="h6">21</Typography>
                      <Typography variant="subtitle1">Reviews</Typography>
                    </div>

                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card className="dash-card">
                  <CardContent className='dash-content'>
                    <Bookmark className="dash-icon  dash-icon-yellow" />

                    <div className='dash-points'>
                      <Typography variant="h6">320</Typography>
                      <Typography variant="subtitle1">Wishlist</Typography>
                    </div>

                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <div className="dash-ratio-main">
              <div className="dash-one">

                <div className="dash-profile-header">
                  <h2 className="dash-profile-title">Your Profile Views</h2>
                  <div className="dash-time-tabs">
                    <span className="dash-tab">Day</span>
                    <span className="dash-tab">Week</span>
                    <span className="dash-tab active">Month</span> {/* Add class "active" for the selected tab */}
                    <span className="dash-tab">Year</span>
                  </div>
                </div>

              </div>
              <div className="dash-two">
                <h2>Notifications</h2>
                <ul className="dash-notification-list">
                  {['Cooper applied for job UI Designer', 'Simmons got a job UX Architect', 'Richards got a job Internet Security',
                    'Russell got a job Developer', 'Wayne got a job Developer', 'Niles applied for role WordPress'].map((note, index) => (
                      <li key={index}>
                        <Notifications className="dash-notification-icon" />
                        {note}
                      </li>
                    ))}
                </ul>
              </div>
            </div>

          </div>


        </div>


      </div>

    </div>
  );
}

export default DashboardCard;
